<template>
    <div
        class="max-w-3xl mx-auto px-4 sm:px-6 md:space-x-5 lg:max-w-7xl lg:px-8 overflow-y-auto"
    >
        <piped-title
            :first="$t('apartments.apartment') + ' ' + apartment.number"
            :second="$t('apartments.overview')"
            :pages="breadcrumbPages"
        ></piped-title>

        <!-- Header -->
        <apartments-header
            :apartment="apartment"
            :project="project"
            :buyers="buyers"
        ></apartments-header>

        <!-- Info Bar -->
        <apartments-infobar :apartment="apartment" :topics="topics" />

        <div class="lg:flex">
            <div class="w-full lg:w-1/2">
                <!-- Pending Approvals -->
                <apartments-pending-approvals
                    :pending-approvals="pendingApprovals"
                ></apartments-pending-approvals>
            </div>
            <!-- Notizen (Thema 7): seit dem Auftrag vom 2026-08-17 kann der
                 Betreuer eine Notiz je Eintrag freigeben. Der Block erscheint
                 NUR dann — `notesLink` liegt beim Käufer ausschliesslich an,
                 wenn mindestens eine Notiz freigegeben ist (Entscheid 7). Das
                 dauerhafte "Keine Notiz vorhanden", an dem der Block in
                 Welle 4 gescheitert ist, kann damit nicht wiederkehren. -->
            <div v-if="notesLink" class="w-full lg:w-1/2 flex">
                <apartments-notes-buyer :notes="notes" :notes-link="notesLink" />
            </div>
        </div>

        <!-- Budget -->
        <apartments-budget
            :apartment="apartment"
            :topics="topics"
            :topicCosts="topicCosts"
            :is-budget-based="feeCalculation ? feeCalculation.isBudgetBased : false"
            :visible-columns="visibleColumns"
            :budget-export-link="
                route('clients.apartments.budget.export', { apartment: apartment.uuid })
            "
            :archive-export-link="
                route('clients.apartments.archive.export', { apartment: apartment.uuid })
            "
        ></apartments-budget>

        <!-- Documents-->
        <document-table :documents="documents"></document-table>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import PipedTitle from "@/Shared/Components/PipedTitle";
import ClientApartmentLayout from "@/Layouts/ClientApartmentLayout";
import ApartmentsHeader from "@/Shared/Components/Apartments/ApartmentsHeader";
import ApartmentsInfobar from "@/Shared/Components/Apartments/ApartmentsInfobar";
import ApartmentsPendingApprovals from "@/Shared/Components/Apartments/ApartmentsPendingApprovals";
import ApartmentsBudget from "@/Shared/Components/Apartments/ApartmentsBudget";
import ApartmentsNotesBuyer from "@/Shared/Components/Apartments/ApartmentsNotesBuyer";
import DocumentTable from "@/Shared/Components/Documents/DocumentTable";

export default defineComponent({
    props: {
        user: Object,
        apartment: Object,
        project: Object,
        buyers: Object,
        topics: Object,
        pendingApprovals: Object,
        topicCosts: Object,
        // Auftrag Luca, 2026-08-17 — siehe Pages/Apartments/Show.vue.
        feeCalculation: Object,
        documents: Object,
        // Thema 1 (Spec docs/superpowers/specs/2026-08-04-welle2-spalten-sichtbarkeit-design.md):
        // fehlt die Prop (Default-Fall), sind alle Spalten sichtbar — der
        // Backend-Vertrag liefert sie nur, wenn eine Konfiguration die volle
        // Spaltenmenge tatsächlich einschränkt.
        visibleColumns: Array,
        // Auftrag Luca, 2026-08-17: beide Props fehlen, solange keine Notiz
        // der Wohnung für den Käufer freigegeben ist (Entscheid 7) — dann
        // bleibt der Block weg und die Seite sieht aus wie vorher.
        notes: Array,
        notesLink: String,
    },
    layout: ClientApartmentLayout,
    components: {
        PipedTitle,
        ApartmentsHeader,
        ApartmentsInfobar,
        ApartmentsPendingApprovals,
        ApartmentsBudget,
        ApartmentsNotesBuyer,
        DocumentTable,
    },
    computed: {
        breadcrumbPages() {
            return [
                {
                    name: this.$t("projects.apartments"),
                    href: this.route("clients.apartments.index"),
                    current: false,
                },
                {
                    name: `${this.$t("apartments.apartment")} ${this.apartment.number}`,
                    href: this.route("clients.apartments.show", { apartment: this.apartment.uuid }),
                    current: true,
                },
            ];
        },
    },
});
</script>

<style scoped></style>
